import { render, staticRenderFns } from "./MobileTags.vue?vue&type=template&id=44eb68d8&scoped=true"
import script from "./MobileTags.vue?vue&type=script&lang=ts"
export * from "./MobileTags.vue?vue&type=script&lang=ts"
import style0 from "./MobileTags.vue?vue&type=style&index=0&id=44eb68d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eb68d8",
  null
  
)

export default component.exports